import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useConfig } from "./contexts/ConfigContext";
import { isTemplateReloginGateOpen } from "./templateReloginGate";

/**
 * forceLoginOnSelectTemplate が有効なテナントでは、/templates 配下へ入る前に
 * ログイン画面での再認証（ゲート通過）を要求する。
 */
function RequireTemplateRelogin() {
  const { features } = useConfig();
  const location = useLocation();

  if (!features?.forceLoginOnSelectTemplate) {
    return <Outlet />;
  }

  if (isTemplateReloginGateOpen()) {
    return <Outlet />;
  }

  const redirect = `${location.pathname}${location.search}`;
  return (
    <Navigate
      to={`/login?redirect=${encodeURIComponent(redirect)}`}
      replace
    />
  );
}

export default RequireTemplateRelogin;
